module.exports = __webpack_public_path__ + "img/sushitatarmicrooverviewgarnelen.17586aee.jpg";